<template>
    <v-list-item @click="select(item)" v-if="item" :class="{'primary--text product-selected' : cartCount > 0 && !adding}">
        <v-list-item-avatar v-if="item.image" tile>
            <v-img :src="item.image"></v-img>
        </v-list-item-avatar>
        <v-list-item-content>
            <v-list-item-title><template v-if="cartCount>0">{{cartCount}}x </template>{{ item.$name || item.name }}
            <v-tooltip bottom v-for="d in item.allergens" :key="d">
                    <template v-slot:activator="{ on, attrs }">
                    <v-icon :color="getConfig('allergens',d).color || 'grey'" small v-bind="attrs"  style="vertical-align: super;"
                    v-on="on">{{getConfig('allergens',d).icon}}</v-icon>
                    </template>
                <span>{{getConfig('allergens',d).text}}</span>
                </v-tooltip>
            </v-list-item-title>
            <v-list-item-subtitle v-if="search">{{item.tab}} - {{item.group}}</v-list-item-subtitle>
            <v-list-item-title v-if="item.$subname || item.subname">{{ item.$subname || item.subname }}</v-list-item-title>
            <v-list-item-subtitle v-if="item.$description || description" v-html="item.$description || description"></v-list-item-subtitle>
            <v-list-item-subtitle v-else-if="item.$include || item.include">{{
            (item.$include || item.include).map((i) => i.name).join(", ")
            }}</v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-action class="caption red--text text-decoration-line-through align-content-start" v-if="getPrice(item)<item.price">
            {{ item.price | toCurrency }}
            <!--v-list-item-action-text>+</v-list-item-action-text-->
        </v-list-item-action>
            <v-list-item-action class="align-content-start" v-if="getPrice(item)==0 && item.volume && item.volume.length>1">
            {{item.volume[0].price | toCurrency}} - {{item.volume[item.volume.length-1].price | toCurrency}}
            <!--v-list-item-action-text>+</v-list-item-action-text-->
        </v-list-item-action>
        <!--v-list-item-action class="align-content-start" v-else-if="item.$price">
             {{ item.$price | toCurrency }}
        </v-list-item-action-->
        <v-list-item-action  class="align-content-start" v-else-if="getPrice(item)==0">
            <!--v-list-item-action-text>+</v-list-item-action-text-->
        </v-list-item-action>
        <v-list-item-action  class="align-content-start" v-else>
            {{ getPrice(item) | toCurrency }}
            <!--v-list-item-action-text>+</v-list-item-action-text-->
        </v-list-item-action>
        </v-list-item>
</template>
<script>
import { mapGetters } from "vuex";
import productItem from "@/modules/productItem";
export default {
     mixins: [productItem],
  props: ['item','search'],
  data () {
    return {
     adding: false
    }
    },
 computed: {
     ...mapGetters(["deliver", "cart"]),
     description() {
      if (!this.item.description) return null
      let d = this.item.description
      d = d.split('- ').filter(s=>s).join('<br>- ')
      if (this.item.description.includes('- ')) d = '- ' + d
      d = d.split(';').filter(s=>s).join('<br>')
      return d
      
    },
    cartCount(){
        let c = this.cart.filter(c=>c._id==this.item._id)[0]
        if (c) return c.$quantity || 1
        return 0
    }
  },
 methods: {
    select() {
        this.adding = true
        this.$emit('select', this.item)
        setTimeout(()=>{
            this.adding = false
        }, 100)
        
    },
    getConfig(key, val){
     return this.$config[key].filter(c=>c.value==val)[0] || {}
    },


  }
}

</script>

<style>
.product-selected {
    animation : pulse 0.5s;
}
@keyframes pulse {
    from {
        transform : scale(1);
        opacity   : 1;
    }
    99% {
        transform : scale(0.75);
        opacity   : 0.25;
        margin-left:100%;
        margin-right:-100%;
    }
    to {
        transform : scale(1);
        opacity   : 1;
    }
}
@-webkit-keyframes pulse {
   0%   { -webkit-transform: scale(1)   ; opacity: 1;    }
   50%  { -webkit-transform: scale(0.75); opacity: 0.25; }
   100% { -webkit-transform: scale(1)   ; opacity: 1;    }
}
</style>
